import React, { createContext, useContext } from 'react';
import { IUserDashboardStore, IUserDashboardEmployee, IUserDashboardPosition, IUserDashboardUnits,IUserDashboardGroups, IUserDashboardPeriod} from 'shared/models';
import { IUserDashboardAssortment } from 'shared/models/UserDashboardModel.ts';

interface DashboardDictionaries {
    stores: IUserDashboardStore[];
    employees: IUserDashboardEmployee[];
    positions: IUserDashboardPosition[];
    units: IUserDashboardUnits;
    periods?: IUserDashboardPeriod[];
    groups?: IUserDashboardGroups;
    assortment?: IUserDashboardAssortment[];
}

const DashboardDictContext = createContext<DashboardDictionaries | null>(null);

export const DashboardDictProvider: React.FC<{ value: DashboardDictionaries, children: React.ReactNode }> = ({ value, children }) => {
    return <DashboardDictContext.Provider value={value}>
        {children}
    </DashboardDictContext.Provider>;
};

export const useDashboardDict = () => {
    const context = useContext(DashboardDictContext);
    if (!context) throw new Error("useDashboardDict must be used within DashboardDictProvider");
    return context;
};

